<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;">
    <div id="background" class="bg">
      <img src="/static/images/feimi/logo.png" alt="" style="width: 20%;position: absolute;top:2.8vh" />
      <img src="/static/images/feimi/feimi.png" alt="" style="width: 95%;position: absolute;top:12vh" />
      <img src="/static/images/feimi/hb.png" alt="" style="width: 60%;position: absolute;top:25vh" />

      <img src="/static/images/feimi/bottom.png" alt="" style="width: 65%;position: absolute;bottom: 0;left: 0;" />


      <!--获取积分弹框开始 -->

      <div style="position: absolute;top:38vh;display: flex;align-items: center;justify-content: center;">
        <img src="/static/images/feimi/lingqudialog.png" alt="" style="width: 75vw;margin-right: 4vw;" />

        <div style="width: 86%;position: absolute;bottom: 27%;z-index: 2;text-align: center;">
          <img src="/static/images/feimi/30.png" v-show="!duplicate && labelId == 49" style="width: 35vw;" />
          <img src="/static/images/feimi/60.png" v-show="!duplicate && labelId == 50" style="width: 35vw;" />
          <img src="/static/images/feimi/120.png" v-show="!duplicate && labelId == 51" style="width: 35vw;" />
          <img src="/static/images/feimi/240.png" v-show="!duplicate && labelId == 52" style="width: 35vw;" />
          <img src="/static/images/feimi/checked.png" v-show="duplicate" style="width: 50vw;" />

        </div>
        <div style="width: 86%;position: absolute;bottom: 5%;z-index: 2;text-align: center;">
          <img src="/static/images/feimi/lingqu.png" style="width: 130px;" v-if="!isAuth"/>

          <wx-open-launch-weapp id="launch-btn" style="z-index: 2;position: relative;" :appid="miniAppId"
            v-if="isAuth && !duplicate" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/lingqu.png" style="width: 130px;height:auto;"/>
                                    </script>
          </wx-open-launch-weapp>

          <wx-open-launch-weapp id="launch-btn" style="z-index: 2;position: relative;" :appid="miniAppId"
            v-if="isAuth && duplicate" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/chakan.png" style="width: 130px;height:auto;"/>
                                    </script>
          </wx-open-launch-weapp>
        </div>
      </div>
      <!--获取积分弹框结束-->

    </div>
    <img src="/static/images/feimi/lingqutip.png" alt="" style="width: 55vw;position: absolute;top:85vh" />
    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>
  </div>
</template>


<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.bg {
  width: 100vw;
  position: fixed;
  background: url(/static/images/feimi/bg.png) no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
}
</style>
<script>
import { getAntiResult, getScoreConfig, getTemplate, getWechatAuth, registerByOpenId, joinActivity, getJSSDK, getInfoByCode } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      authCode: "",
      isAuth: false,
      deptId: 0,
      eno: '138458970754',
      activityId: 0,
      duplicate: false,
      labelId: 0,
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      userToken: "",
      isShow: false,
      isSnapUser: ""
    }
  },
  methods: {
    async getCodeInfo() {
      var res = await getInfoByCode(this.antiCode)
      this.labelId = res.data.data.labelId
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      getWechatAuth(url, "wx3692a2a68854c4d5", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getResult() {
      this.isShow = true
      const params = this.$route.query
      const code = params.c
      this.antiCode = code.substring(0, 16);
      var res = await getAntiResult(code);
      const data = res.data;
      this.isShow = false
      if (data == null || data.code == "500") {
        alert("查询失败,请稍后重新扫码查询")
      } else if (data.code == "300106") {
        alert("数码不存在，谨防假冒")
      } else {
        this.deptId = data.data.deptId
        this.getCodeInfo()

        const authCode = this.$route.query.wyAuthCode
        if (authCode != null && authCode != undefined && this.isSnapUser != "1") {
          this.authCode = authCode
          this.isAuth = true
          this.joinActivity()
        }
      }

    },
    async getTemplate() {
      var res = await getTemplate(this.deptId)

      if (res != null && res.data.data != null) {
        this.activityId = res.data.data.activityId;
      }
    },
    async getScoreConfig() {
      var res = await getScoreConfig(this.deptId);
      if (res != null && res.data.data != null) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }

    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx3692a2a68854c4d5").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async joinActivity() {
      await this.getScoreConfig()
      await this.getTemplate();
      if (this.activityId > 0) {
        const res = await registerByOpenId(this.eno, this.authCode);
        if (res != null && res.data.data != null) {
          this.userToken = res.data.data.token;
          var data = {
            code: this.antiCode,
            activityId: this.activityId,
            authCode: this.authCode,
            userToken: this.userToken
          }
          const ret = await joinActivity(data);
          if (ret.data.code == "200") {
            this.duplicate = false
          } else if (ret.data.code == "500001") {
            this.duplicate = true
          } else {
            alert("参与营销活动失败")
          }
        }
      } else {
        alert("暂无可参与的活动")
      }


    }
  },
  mounted: function () {
    var params = this.$route.query
    const authCode = params.wyAuthCode
    this.isSnapUser = params.isSnapshotUser
    if (authCode != null && authCode != undefined) {
      this.getWxJs()
      this.getResult()

    } else {
      this.getAuth()
    }



  }
}
</script>



// WEBPACK FOOTER //
// src/components/Feimi/Index.vue